<template>
  <div
    v-if="categories?.length"
    class="scrollbar-none order-last mb-[38px] flex w-full gap-12 overflow-auto px-16 md:mb-0 md:px-0 xl:order-none xl:w-auto"
  >
    <DrupalLink
      v-for="item in categories"
      :key="item.value"
      class="button"
      :class="{
        'border-black text-black': mode === item.value,
      }"
      :to="item.to"
    >
      {{ item.label }}
    </DrupalLink>
  </div>
</template>

<script lang="ts" setup>
import { ProductFinderMode } from '#graphql-operations'

defineProps<{
  mode: ProductFinderMode
}>()

const { $texts } = useNuxtApp()
const route = useRoute()

const categories = computed(() => {
  return [
    {
      label: $texts('productFinder.watchesCurrent', 'Current'),
      value: ProductFinderMode.Watches_actual,
      to: {
        path: route.path,
        query: {
          ...route.query,
          page: undefined,
          mode: undefined,
        },
      },
    },
    {
      label: $texts('productFinder.watchesLimitedEdition', 'Limited Editions'),
      value: ProductFinderMode.Watches_limited,
      to: {
        path: route.path,
        query: {
          ...route.query,
          page: undefined,
          mode: ProductFinderMode.Watches_limited,
        },
      },
    },
    {
      label: $texts('productFinder.watchesArchived', 'Archived'),
      value: ProductFinderMode.Watches_archived,
      to: {
        path: route.path,
        query: {
          ...route.query,
          page: undefined,
          mode: ProductFinderMode.Watches_archived,
        },
      },
    },
  ]
})
</script>

<style lang="postcss" scoped>
.scrollbar-none {
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 0;
    height: 0;
  }
}
</style>
